import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { Control } from './logic/control';

const createProvider = (Context) => {
  return ({ initialState, children }) => {
    const [control] = useState(() => {
      return new Control(initialState);
    });

    return <Context.Provider value={control}>{children}</Context.Provider>;
  };
};

const createSelector = (Context) => {
  return (selector, isEqual = Object.is) => {
    const control = useContext(Context);

    const isEqualRef = useRef(isEqual);
    isEqualRef.current = isEqual;

    const [value, setValue] = useState(() => {
      return selector(control.methods.getState());
    });

    useLayoutEffect(() => {
      return control.subscribe((state) => {
        const current = selector(state);

        setValue((prev) => {
          return isEqualRef.current(prev, current) ? prev : current;
        });
      });
    }, [control, selector]);

    return value;
  };
};

const createMethods = (Context) => {
  return () => {
    const control = useContext(Context);

    const [methods] = useState(() => control.methods);

    return methods;
  };
};

export const createReactiveContext = () => {
  const Context = createContext();

  return {
    Provider: createProvider(Context),
    useSelector: createSelector(Context),
    useMethods: createMethods(Context),
  };
};
